var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.667,
    height: 18.667,
    viewBox: "0 0 18.667 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3479",
    "data-name": "Trazado 3479",
    d: "M9.333,18.667a9.333,9.333,0,1,1,9.333-9.333A9.333,9.333,0,0,1,9.333,18.667Zm0-17.5A8.167,8.167,0,1,0,17.5,9.334,8.167,8.167,0,0,0,9.333,1.167Zm0,0",
    fill: "#989898"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3480",
    "data-name": "Trazado 3480",
    d: "M136.763,241.167H128.6a.583.583,0,0,1,0-1.166h8.167a.583.583,0,0,1,0,1.167Zm0,0",
    transform: "translate(-123.347 -231.25)",
    fill: "#989898"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3481",
    "data-name": "Trazado 3481",
    d: "M240.583,137.333a.583.583,0,0,1-.583-.583v-8.166a.583.583,0,0,1,1.167,0v8.167a.583.583,0,0,1-.583.583Zm0,0",
    transform: "translate(-231.25 -123.333)",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1a41c0e7366fc91126be824024dcd9e4.svg";
export { ForwardRef as ReactComponent };